import React from "react";
import { Box, Stack } from "@mui/material";
import RevaText from "components/common/RevaText";

const GestionPageHeader = ({ title, subtitle, actions }) => (
  <Stack spacing={3}>
    <Box>
      <RevaText variant="h4">{title}</RevaText>
      {subtitle ? (
        <RevaText variant="body1" color="text.secondary" sx={{ mt: 0.5 }}>
          {subtitle}
        </RevaText>
      ) : null}
    </Box>
    {actions ? (
      <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
        {actions}
      </Stack>
    ) : null}
  </Stack>
);

export default GestionPageHeader;
